import {BaseConstants} from "../constants/BaseConstants";
import SchedulingService from "../scheduling-service/SchedulingService";
import ParameterService from "../parameter/ParameterService";
import LookupService from "../lookup/LookupService";
import LookupCache from "../lookup/LookupCache";

export * from './alert.actions';

export * from './user.actions';

export * from './emr.actions';

export const getSchedules = () => {
    return dispatch => {
        dispatch({type: BaseConstants.SCHEDULES, value: []});

        SchedulingService.getSchedules((schedules) => {
            dispatch({type: BaseConstants.SCHEDULES, value: schedules});
        });
    };
}

export const getParameters = () => {
    return dispatch => {
        dispatch({type: BaseConstants.PARAMETERS, value: {}});

        ParameterService.getParameters(parameterMap => {
            dispatch({type: BaseConstants.PARAMETERS, value: parameterMap});
        });
    };
}

/**
 * Builds an action creator for a cached lookup.
 *
 * The cached copy is pushed to the store first so dropdowns are populated on the very
 * first render, and the network is skipped entirely while that copy is still fresh.
 * A refetched payload is only dispatched when it differs from the cached one, so the
 * object references already handed to mounted components stay stable.
 */
const cachedLookupAction = (type, cacheKey, fetchLookup) => () => {
    return dispatch => {
        const cached = LookupCache.read(cacheKey);

        if (cached) {
            dispatch({type, value: cached.data});

            if (cached.fresh) {
                return;
            }
        }

        fetchLookup(value => {
            if (LookupCache.store(cacheKey, value)) {
                dispatch({type, value});
            }
        });
    };
}

export const getNationalities = cachedLookupAction(
    BaseConstants.NATIONALITIES, 'nationalities', callback => LookupService.getNationalities(callback));

export const getCountries = cachedLookupAction(
    BaseConstants.COUNTRIES, 'countries', callback => LookupService.getCountries(callback));

export const getLanguages = cachedLookupAction(
    BaseConstants.LANGUAGES, 'languages', callback => LookupService.getLanguages(callback));

export const getReligions = cachedLookupAction(
    BaseConstants.RELIGIONS, 'religions', callback => LookupService.getReligions(callback));

export const getMaritalStatuses = cachedLookupAction(
    BaseConstants.MARITAL_STATUS, 'maritalStatuses', callback => LookupService.getMaritalStatuses(callback));

export const getRelationshipTypes = cachedLookupAction(
    BaseConstants.RELATIONSHIP_TYPES, 'relationshipTypes', callback => LookupService.getRelationshipTypes(callback));

export const getAllergyTypes = cachedLookupAction(
    BaseConstants.ALLERGY_TYPES, 'allergyTypes', callback => LookupService.getAllergyTypes(callback));

export const getAllergenTypes = cachedLookupAction(
    BaseConstants.ALLERGEN_TYPES, 'allergenTypes', callback => LookupService.getAllergenTypes(callback));

export const getAllergenReactionTypes = cachedLookupAction(
    BaseConstants.ALLERGEN_REACTION_TYPES, 'allergenReactionTypes', callback => LookupService.getAllergenReactionTypes(callback));

export const getAllergySeverityTypes = cachedLookupAction(
    BaseConstants.ALLERGY_SEVERITIES, 'allergySeverityTypes', callback => LookupService.getAllergySeverityTypes(callback));

export const getGenders = cachedLookupAction(
    BaseConstants.LOOKUP_GENDERS, 'genders', callback => LookupService.getGenders(callback));

export const getEmploymentStatuses = cachedLookupAction(
    BaseConstants.EMPLOYMENT_STATUSES, 'employmentStatuses', callback => LookupService.getEmploymentStatuses(callback));

export const getEducationLevels = cachedLookupAction(
    BaseConstants.EDUCATION_LEVELS, 'educationLevels', callback => LookupService.getEducationLevels(callback));

export const getSmokingDevices = cachedLookupAction(
    BaseConstants.SMOKING_DEVICES, 'smokingDevices', callback => LookupService.getSmokingDevices(callback));

export const getSmokingStatuses = cachedLookupAction(
    BaseConstants.SMOKING_STATUSES, 'smokingStatuses', callback => LookupService.getSmokingStatuses(callback));

export const getDrinkingStatuses = cachedLookupAction(
    BaseConstants.DRINKING_STATUSES, 'drinkingStatuses', callback => LookupService.getDrinkingStatuses(callback));

export const getSubstanceAbuseStatuses = cachedLookupAction(
    BaseConstants.SUBSTANCE_ABUSE_STATUSES, 'substanceAbuseStatuses', callback => LookupService.getSubstanceAbuseStatuses(callback));

export const getMedicationRoutes = cachedLookupAction(
    BaseConstants.MEDICATION_ROUTES, 'medicationRoutes', callback => LookupService.getMedicationRoutes(callback));

export const getMedicationUnits = cachedLookupAction(
    BaseConstants.MEDICATION_UNITS, 'medicationUnits', callback => LookupService.getMedicationUnits(callback));
